import { Component, EventEmitter, Input, OnInit, Output, SkipSelf } from '@angular/core';
import { ControlContainer, FormGroup, NgForm } from '@angular/forms';
import { AuthModel } from 'src/app/modules/auth/models/auth.model';
import { PageableModel } from '../../models/pageable.model';
import { CrudService } from '../../services/crud.service';
import { AuthQuery } from 'src/app/modules/auth/state/auth.query';
import { UserModel } from 'src/app/modules/auth/models/user.model';

@Component({
  selector: 'app-userpicker',
  templateUrl: './userpicker.component.html',
  styleUrls: ['./userpicker.component.scss'],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }]
})
export class UserpickerComponent implements OnInit {
  @Input() model!: number;
  @Input() name!: string;
  @Input() placeholder!: string;
  @Input() required = false;
  @Input() disabled = false;
  @Input() myForm!: NgForm;
  @Input() selectCurrentUser = true;
  @Input() excludeUsers = new Array<any>();
  @Input() excludeField = '';
  @Input() includeUsers = new Array<any>();
  @Input() includeField = '';
  @Output() modelChange = new EventEmitter<number>();
  @Output() userOutput = new EventEmitter<UserModel>();

  users: UserModel[] = new Array<UserModel>();
  public auth = this.authQuery.auth;

  @Input() emptyChoice = false;
  @Input() emptyModel!: any;

  constructor(private crudService: CrudService<UserModel>, private authQuery: AuthQuery) { }

  ngOnInit(): void {
    this.crudService.getPage('users', 0, 100, 'created.desc', {})
      // tslint:disable-next-line: deprecation
      .subscribe(
        (utenti: PageableModel<UserModel>) => {
          this.users = utenti.content;
          if (this.excludeUsers.length > 0) {
            this.users = this.users.filter((u: any) => this.excludeUsers.findIndex(c => c === u[this.excludeField]) === -1);
          }
          if (this.includeUsers.length > 0) {
            this.users = this.users.filter(
              (i: any) => this.includeUsers.indexOf(this.includeField.split('.').reduce((a: any, b: any) => typeof a === 'object' ? a[b] : a, i)) > -1);
          }
          if (this.selectCurrentUser && !this.model) {
            // tslint:disable-next-line: no-non-null-assertion
            this.model = this.auth?.user?.id!;
            this.eventChange();
          }
        },
        error => {

        },
        () => {
        });
  }

  eventChange(): void {
    this.modelChange.emit(this.model);
    this.userOutput.emit(this.users.find(u => u.id === this.model));
  }

}


